document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pack-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');

      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      document.querySelectorAll('.pack-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });
});
